export default {
  apiKey: import.meta.env.VITE_FROALA_API_KEY,
};
